// =============================================================================
// DATA / DRESSES-VANCOUVER.JS — Wedding dress boutiques (Vancouver & Sea-to-Sky)
// Simple format: { name, ig, url, link }
// =============================================================================

export const vancouverDressData = [
  { name: "Leila + Lace Bridal", ig: "@leilaandlacebridal", url: "leilaandlacebridal.com", link: "https://www.leilaandlacebridal.com" },
  { name: "Bisou Bridal", ig: "@bisou_bridal", url: "bisoubridal.com", link: "https://bisoubridal.com" },
  { name: "The Bridal Gallery", ig: "@thebridalgallery", url: "thebridalgallery.com", link: "https://www.thebridalgallery.com" },
  { name: "Rituals of Love", ig: "@ritualsoflovebridal", url: "ritualsoflovebridal.com", link: "https://ritualsoflovebridal.com" },
  { name: "Luxx Nova Bridal Boutique", ig: "@luxxnova_boutique", url: "luxx-nova.com", link: "https://www.luxx-nova.com" },
  { name: "Everly Bridal", ig: "@everly_bridal", url: "everlyfinebridal.com", link: "https://www.everlyfinebridal.com" },
  { name: "LOVENOTE Vancouver", ig: "@lovenotebride", url: "lovenotebride.com/pages/vancouver", link: "https://lovenotebride.com/pages/vancouver" },
  { name: "Vimo Wedding", ig: "@vimowedding", url: "vimowedding.com", link: "https://vimowedding.com" },
];
